import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="compra" className="w-full bg-sand-100 py-24 md:py-32 px-6" data-id="element-79">
      <div className="max-w-xl mx-auto text-center flex flex-col items-center" data-id="element-80">
        <div className="mb-10" data-id="element-81">
          <CTAButton className="px-12 py-5 text-lg" data-id="element-82">
            Acceder a Florecer
          </CTAButton>
        </div>

        <div className="text-charcoal-400 tracking-wider uppercase space-y-2" data-id="element-83">
          <p className="text-xl font-medium text-charcoal-600" data-id="element-84">$19.990 ARS</p>
          <p className="text-sm font-light" data-id="element-85">Acceso inmediato</p>
        </div>
      </div>
    </section>;
}